'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  viewBox: '0 0 24 24',
  width: 24,
  height: 24,
  fill: 'none',
  stroke: '#6E0AD6',
  strokeWidth: '2',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  polylines: ['6 9 12 15 18 9']
};